// extracted by mini-css-extract-plugin
module.exports = {"stakeUnit":"StakeUnit_stakeUnit__1Ewfa","stakingGuideContainer":"StakeUnit_stakingGuideContainer__2LsuF","stakingGuideColumn":"StakeUnit_stakingGuideColumn__hju9P"};